export default function volumeToDecibel(volume) {
	return Math.round(6 * Math.log2(volume) * 100) / 100;
}
